/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Sign_OutInputs */

const en_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign Out`)
};

const de_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmelden`)
};

const fr_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se déconnecter`)
};

const es_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar sesión`)
};

const it_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esci`)
};

const nl_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitloggen`)
};

const pl_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyloguj się`)
};

const fi_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjaudu ulos`)
};

const da_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log ud`)
};

const sv_nav_sign_out = /** @type {(inputs: Nav_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logga ut`)
};

/**
* | output |
* | --- |
* | "Sign Out" |
*
* @param {Nav_Sign_OutInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const nav_sign_out = /** @type {((inputs?: Nav_Sign_OutInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Sign_OutInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nav_sign_out(inputs)
	if (locale === "fr") return fr_nav_sign_out(inputs)
	if (locale === "es") return es_nav_sign_out(inputs)
	if (locale === "it") return it_nav_sign_out(inputs)
	if (locale === "nl") return nl_nav_sign_out(inputs)
	if (locale === "pl") return pl_nav_sign_out(inputs)
	if (locale === "fi") return fi_nav_sign_out(inputs)
	if (locale === "da") return da_nav_sign_out(inputs)
	if (locale === "sv") return sv_nav_sign_out(inputs)
	return en_nav_sign_out(inputs)
});